<template>
  <div class="myRender_wrap english_container">
    <myHeader />
    <!-- banner模块 -->
    <!-- <div class="banner">
      <p style="font-size: 89px; font-weight: 700" class="wow fadeInUp">
        Real-time Rendering and Interaction
      </p>
      <p
        style="font-size: 36px; font-weight: 700; margin-top: 40px"
        class="wow fadeInUp"
      >
        Easily build complex and engaging interactive scenes
      </p>
    </div> -->

    <div class="banner">
      <canvas id="threeCanvas" ref="threeCanvas"></canvas>
      <div class="banner_content">
        <p
          style="font-size: 80px; font-weight: 900; color: #000000"
          class="wow fadeInUp enProductTitle"
        >
          Real-time Rendering and Interaction
        </p>
        <p
          style="font-size: 36px; font-weight: 700; margin-top: 10px"
          class="wow fadeInUp enTwoProductTitle"
        >
          Easily build complex and engaging interactive scenes
        </p>

        <router-link
          id="render_interaction_contact_us"
          class="callMe"
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
          >Contact Us</router-link
        >
      </div>
    </div>

    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p class="wow fadeInUp enProductTitle">
        Start by Highlighting the Key Points
      </p>
      <p
        style="font-size: 24px; color: rgba(255, 255, 255, 0.64)"
        class="wow fadeInUp"
      >
        Advantages of Real-time Rendering and Interaction
      </p>
      <img
        v-show="isFirstImage1"
        src="https://download.hecoos.com/enlightv/2025-17/8dc963c65351d2b39e1a034934b48eea.png"
        alt=""
        class="wow fadeInUp"
      />
      <img
        v-show="isFirstImage2"
        src="https://download.hecoos.com/enlightv/2025-17/c52ef6a9594d1abf55fea0e923e8117b.png"
        alt=""
      />
      <div class="button_container wow fadeInUp" ref="button_list">
        <button
          :class="{ btn: true, active: isBtn1Active }"
          @click="switchContent(1)"
        >
          Real-time Rendering Block/SDK
        </button>
        <button
          :class="{ btn: true, active: isBtn2Active }"
          @click="switchContent(2)"
        >
          Tracking and Sensor Integration
        </button>
        <div
          class="underline"
          :style="{
            width: buttonUnderlineWidth + 'px',
            left: buttonUnderlineLeft + 'px',
          }"
        ></div>
      </div>
      <div class="text enProductCont">
        <p v-show="isFirstImage1" class="wow fadeInUp">
          hecoos integrates industry-standard rendering engines (Notch, Unity,
          Unreal Engine, TouchDesigner) and captures interactive feeds via
          Spout, NDI, or hardware capture cards
        </p>
        <p v-show="isFirstImage2">
          Tracking system data
          integration（VICON、blacktrax、optitrack、stype、Mo-sys、Redspy,
          etc.） Sensor integration（Radar、IR、Pressure sensitivity、kinnect,
          etc.） Open-source hardware integration（ARDUINO、Raspberry Pi, etc.）
        </p>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application_scene">
      <p
        style="font-size: 60px; margin-bottom: 24px"
        class="wow fadeInUp enProductTitle"
      >
        Application Scenarios
      </p>
      <p
        style="font-size: 24px; color: rgba(255, 255, 255, 0.64)"
        class="wow fadeInUp"
      >
        Practical Applications of Real-time Rendering and Interaction
      </p>
      <myBanner :applicationInfo="applicationInfo" class="wow fadeInUp" />
    </div>

    <!-- 产品模块 -->
    <div class="product colorBlack">
      <div class="tab">
        <p class="enProductTitle wow fadeInUp" style="margin-bottom: 0px">
          Product
        </p>
        <p class="wow fadeInUp enProductTitle">
          Your Real-time Rendering and Interaction Toolkit
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span
            :class="{ select: currentTabIndex === 0 }"
            @click="selectTab(0)"
          >
            Server-D
          </span>
          <span
            :class="{ select: currentTabIndex === 1 }"
            @click="selectTab(1)"
          >
            Server-R
          </span>
          <div
            class="underline1"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png"
                alt=""
              />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px">
                  Server-D
                </p>
                <p class="enProductCont" style="margin-bottom: 90px">
                  Relying on the hecoos workflow, we maximize control over every
                  aspect from conceptual inspiration to final presentation,
                  embodying the product design philosophy of "Design is
                  realization.
                </p>
                <router-link
                  class="render_call"
                  :to="{ path: '/en/mediaServer??section=0', hash: '#tab' }"
                >
                  Learn more
                </router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png"
                alt=""
              />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px">
                  Server-R
                </p>
                <p class="enProductCont" style="margin-bottom: 120px">
                  When faced with heavy and complex real-time rendering tasks,
                  the powerful rendering capabilities of hecoos Server-R can
                  also provide thoughtful support for virtual content creators
                </p>
                <router-link
                  class="render_call"
                  :to="{ path: '/en/mediaServer??section=2', hash: '#tab' }"
                >
                  Learn more
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 创意模块 -->
    <Creativity :imgUrl="imgUrl" />
    <myFooter />
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import Creativity from "@/components/en_pc/creativity";
import myBanner from "@/components/en_pc/myBanner";
import BackToTop from "@/components/en_pc/BackToTop";
import G from "@/utils/render_interaction_canvas.js";

export default {
  data() {
    return {
      isFirstImage1: true,
      isFirstImage2: false,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false],
      underlineWidth: 0,
      underlineLeft: 0,
      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
      imgUrl:
        "https://download.hecoos.com/enlightv/2025-17/70a8a0bd16927f414fc5369552198623.png",
      applicationInfo: [
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/8e0211a35160113c1a748086d6006798.png",
          title: "Concert",
          msg: "By integrating multi-engine rendering (Notch/Unity/Unreal Engine/TouchDesigner) and cross-platform tracking data, hecoos delivers breathtaking visual effects that synchronize flawlessly with performer movements, crafting unparalleled multi-sensory experiences.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/bc8e64755519ac04a0d1b1b398e9af1e.png",
          title: "Stage Performance",
          msg: "Through collaborative hecoos previsualization, artists and engineers jointly validate every design detail in real time. This shared workflow foundation propels productions toward flawless execution and visually compelling outcomes.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/d464d7fad4f317f5f8e2aa2c6e5d2738.png",
          title: "Immersive Exhibition",
          msg: "HeCoos seamlessly integrates multiple real-time rendering engines with sensors, ingeniously combines them with video, lighting, mechanical and other equipment, and uniformly controls the playback. It builds a creative realization platform for artists, fully unleashing the unlimited potential of artistic creation.",
        },
      ],
      threeScene: null,
      spheres: null,
    };
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
      window.addEventListener("resize", this.buttonUpdateUnderlinePosition);
    });
    const canvas = this.$refs.threeCanvas;
    const options = {
      // 这里可以传入自定义参数
    };
    this.threeScene = G(canvas, options);
    this.spheres = this.threeScene.spheres;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
    if (this.threeScene) {
      this.threeScene.dispose();
      this.threeScene = null;
      this.spheres = null;
    }
  },
  methods: {
    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition();
      if (type === 1) {
        this.isFirstImage1 = true;
        this.isFirstImage2 = false;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
      } else {
        this.isFirstImage1 = false;
        this.isFirstImage2 = true;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button =
          switchList.querySelectorAll("button")[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft =
          spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }
    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll("button");
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach((button) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";
.underline {
  position: absolute;
  display: inline-block;
  height: 56px;
  border-radius: 32px;
  top: 5px;
  cursor: pointer;
  background-color: #000;
  color: white;
  border: 2px solid #00b4ff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.callMe {
  display: inline-block;
  text-decoration: none;
  padding: 16px 24px;
  line-height: 32px;
  border-radius: 40px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 22px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
</style>
